import React, { useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Loader from "modules/Loader";
import NoData from "assets/svgs/no_data/NoData";

const getStatusColor = (status) => {
  switch (status) {
    case "Open":
      return "rgba(3,122,252, 0.6)";
    case "Resolved":
      return "rgba(77,163,184, 0.6)";
    case "Closed":
      return "rgba(118,212,125, 0.6)";
    case "Pending":
      return "rgba(220,63,69, 0.6)";
    default:
      return "rgba(0, 0, 0, 0.6)";
  }
};

const ChartsOptions = ({ data, loading, chartType }) => {
  const groupedData = {};

  data?.forEach((item) => {
    const { date, status } = item._id;

    if (!groupedData[date]) {
      groupedData[date] = {};
    }

    if (!groupedData[date][status]) {
      groupedData[date][status] = 0;
    }

    groupedData[date][status] += item.value;
  });

  const statuses = [...new Set(data?.map((item) => item._id.status))];
  const dates = Object.keys(groupedData);

  const chartData = {
    labels: dates,
    datasets: statuses.map((status) => {
      const values = dates?.map((date) => groupedData[date][status] || 0);

      return {
        label: status,
        data: values,
        backgroundColor: getStatusColor(status),
        borderColor: getStatusColor(status),
        fill: false,
      };
    }),
  };

  const sumData = statuses.map((status) =>
    dates.reduce(
      (dateSum, date) => dateSum + (groupedData[date]?.[status] || 0),
      0
    )
  );

  chartData.datasets.forEach((dataset, index) => {
    dataset.label += ` (Sum: ${sumData[index]})`;
  });

  return (
    <div className={"w-75"}>
      {loading ? (
        <div className="position-absolute start-50 translate-middle mt-5">
          <Loader />{" "}
        </div>
      ) : data?.length === 0 ? (
        <div className="w-100 d-flex">
          <h3 className="p-3 ">Data is not Available</h3>
          <span>
            <NoData />
          </span>
        </div>
      ) : chartType === "bar" ? (
        <Bar data={chartData} />
      ) : (
        <Line data={chartData} />
      )}
    </div>
  );
};

export default ChartsOptions;
